import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';

@Component({
  selector: 'app-case-info',
  templateUrl: './case-info.component.html',
  styleUrls: ['./case-info.component.css']
})
export class CaseInfoComponent {
  constructor(
    private dialogRef: MatDialogRef<CaseInfoComponent>,
    @Inject(MAT_DIALOG_DATA) private data: CaseInfoInput
  ) {
    this.caseDetails = this.data.caseDetails;
    this.printMode = this.data.printMode;
  }

  caseDetails: any;
  printMode: boolean = false;

  ngAfterViewInit() {
    if (this.printMode) {
      setTimeout(() => {
        EventAggregator.publish(EventList.caseDetailPrint, {
          dialog: this.dialogRef
        });
      }, 1500);
    }
  }

  detailsForCase(caseDetails) {
    const middle = caseDetails.OCMEData["NAME_MIDDLE"] ? ' ' + caseDetails.OCMEData["NAME_MIDDLE"] +' ': '';
    return  caseDetails.OCME + "\t" + caseDetails.OCMEData["NAME_FIRST"] + middle
   + " " + caseDetails.OCMEData["NAME_LAST"]
  }

  onCloseModal(event: any){
    this.dialogRef.close();
  }
}

interface CaseInfoInput {
  caseDetails: any,
  printMode: boolean
}